import * as React from "react";
import Card from "@mui/material/Card";
import { useState, useEffect } from "react";
import { Snackbar, Alert } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import LogIn from "../../assets/images/Login.png";
import styled from "styled-components";
import { Box, TextField } from "@mui/material";
import * as yup from "yup";
import axios from "axios";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

const ErrorText = styled.p`
  color: red;
`;
const ButtonStyle = styled.button`
  width: 220px;
  height: 50px;
  background-color: #c7131c;
  color: #eee;
  font-size: 16px;
  font-weight: bold;
  border-color: #c7131c;
  border-radius: 5px;
`;
export default function SignIn({ isLoggedIn, setIsLoggedIn }) {
  useEffect(() => {
    document.title = "Log In";
    return () => {
      document.title = "404";
    };
  }, []);
  const schema = yup.object().shape({
    username: yup
      .string("validation.invalid user name")
      .required("Username is required"),
    password: yup
      .string("validation.invalid password")
      .required("Password is required"),
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onTouched",
  });
  const handleCloseSnack = () => {
    setSnack(false);
  };
  const [snack, setSnack] = useState(false);
  async function registerHandler(data) {
    const LoginSchema = {
      userName: "",
      password: "",
      roleID: 3,
    };

    try {
      const response = await axios.post(
        "https://anydev.com-eg.net/api/Users/V1/Login",
        { ...LoginSchema, ...data },
        {
          headers: {
            CompanyID: "241701",
          },
        }
      );

      const userStorage = response.data.data;
      console.log(userStorage.accessToken);

      // ❗️ تأكد أن accessToken موجود
      if (userStorage && userStorage.accessToken) {
        // خزن الـ accessToken فقط
        localStorage.setItem("accessToken", userStorage.accessToken);

        // وإذا أردت تخزين كل البيانات:
        localStorage.setItem("userStorage", JSON.stringify(userStorage));

        setIsLoggedIn(true);
        reset();
      } else {
        setSnack(true); // عرض رسالة خطأ
      }
    } catch (error) {
      console.error("Login failed:", error);
      setSnack(true);
    }
  }
  useEffect(() => {
    document.title = "Log In";
    const token = localStorage.getItem("accessToken");
    if (token) {
      setIsLoggedIn(true);
    }
  }, []);
  return (
    <Card
      sx={{
        maxWidth: 345,
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: 500,
        bgcolor: "background.paper",
        border: "2px solid #eee",
        boxShadow: 50,
        p: 4,
        borderRadius: "10px",
      }}
    >
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <img src={LogIn} alt="LogIn" width={150} />
      </Box>
      <form onSubmit={handleSubmit(registerHandler)}>
        <CardContent
          sx={{ display: "flex", flexDirection: "column", gap: "15px" }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              margin: "-15px",
            }}
          >
            <TextField
              id="outlined-basic"
              label="User Name"
              variant="outlined"
              sx={{ width: "222px" }}
              {...register("username", {
                required: "* User Name Is Required",
              })}
            />
            <ErrorText>{errors.Username?.message}</ErrorText>
          </Box>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              margin: "-15px",
            }}
          >
            <TextField
              id="outlined-password-input"
              sx={{ width: "222px" }}
              label="Password"
              type="password"
              {...register("password", {
                required: "* Password Is Required",
              })}
            />
            <ErrorText>{errors.Password?.message}</ErrorText>
          </Box>
        </CardContent>
        <CardActions sx={{ display: "flex", justifyContent: "center" }}>
          <ButtonStyle type="submit">Log In</ButtonStyle>
        </CardActions>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          open={snack}
          autoHideDuration={4000}
          onClose={handleCloseSnack}
        >
          <Alert severity="error">Un Expected error Happened !</Alert>
        </Snackbar>
      </form>
    </Card>
  );
}
